module.exports = __webpack_public_path__ + "img/creat.1775439203884.png";